import { render, staticRenderFns } from "./hospitaler.vue?vue&type=template&id=1c5e85b3&scoped=true&"
import script from "./hospitaler.vue?vue&type=script&lang=js&"
export * from "./hospitaler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e85b3",
  null
  
)

export default component.exports